// src/components/routes/PrivateRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const SuspendedView = ({ message }) => (
  <div className="min-h-screen flex items-center justify-center p-6">
    <div className="max-w-lg text-center bg-white p-8 rounded-lg shadow">
      <h1 className="text-5xl font-bold text-pink-600 mb-3">403</h1>
      <h2 className="text-2xl font-semibold mb-2">Compte suspendu</h2>
      <p className="text-gray-600 mb-6">
        {message || "Votre compte est suspendu. Contactez le support pour plus d'informations."}
      </p>
      <div className="flex justify-center space-x-3">
        <a href="/" className="px-4 py-2 bg-gray-100 rounded hover:shadow">Accueil</a>
        <a href="/login" className="px-4 py-2 bg-primary-600 text-white rounded hover:shadow">
          Se connecter
        </a>
      </div>
    </div>
  </div>
);

const AccessDeniedView = ({ title = "Accès non autorisé", message }) => (
  <div className="min-h-screen flex items-center justify-center p-6">
    <div className="max-w-lg text-center bg-white p-8 rounded-lg shadow">
      <h1 className="text-4xl font-bold text-yellow-600 mb-3">403</h1>
      <h2 className="text-2xl font-semibold mb-2">{title}</h2>
      <p className="text-gray-600 mb-6">
        {message || "Vous n'êtes pas autorisé à accéder à cette page."}
      </p>
      <div className="flex justify-center space-x-3">
        <a href="/" className="px-4 py-2 bg-gray-100 rounded hover:shadow">Accueil</a>
      </div>
    </div>
  </div>
);

const PrivateRoute = ({ children, allowedRoles = null }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.isSuspended || user.status === 'suspended' || user.suspended) {
    return (
      <SuspendedView message="Votre compte a été suspendu. Contactez le support pour réactiver votre compte." />
    );
  }

  if (
    allowedRoles &&
    Array.isArray(allowedRoles) &&
    !allowedRoles.includes(user.role || 'user')
  ) {
    return (
      <AccessDeniedView message="Vous n'avez pas le rôle requis pour accéder à cette page." />
    );
  }

  return children;
};

export default PrivateRoute;
